import { styled } from '@mui/material/styles';

export const FormStyled = styled('form')({
	flex: '1 1 auto',
	display: 'flex',
	flexDirection: 'column',
	gap: 16,
	gridArea: 'content',
});

export const Bold = styled('span')(() => ({
	fontWeight: '600',
}));
